import ColorfulModal from './colorful-modal';
export default ColorfulModal;
